import { Middleware, ResponseContext } from '../../../generated/api';
import { Timestamp } from '../../firebase/firebaseAccess';

export function transcodeTimestamp<T>(target: T): T {
  const input = target as any;
  if (input == null) {
    return input;
  }
  if (typeof input !== 'object') {
    return input;
  }
  if (Array.isArray(input)) {
    return input.map(transcodeTimestamp) as any;
  }
  if (
    typeof input['_nanoseconds'] === 'number' &&
    typeof input['_seconds'] === 'number'
  ) {
    return new Timestamp(input._seconds, input._nanoseconds) as any;
  }
  const result = {} as any;
  for (const key of Object.keys(input)) {
    result[key] = transcodeTimestamp(input[key]);
  }
  return result;
}

class FirestoreTimestampMiddleware implements Middleware {
  async post(context: ResponseContext): Promise<Response | void> {
    if (!context.response.ok) {
      return context.response;
    }
    const response = context.response.clone();
    async function json() {
      return transcodeTimestamp(await context.response.json());
    }
    Object.assign(response, { json });
    return response;
  }
}

export default FirestoreTimestampMiddleware;
